// extracted by mini-css-extract-plugin
export default {"reservation-form":"ReservationForm_reservation-form__Op6RP","agree":"ReservationForm_agree__qLvTN","submit":"ReservationForm_submit__ivtOY"};